import type { RootState } from "@store/index";

export const getIsAuth = (state: RootState) => state.user?.isAuth;
export const getUserFullName = (state: RootState) => state.user?.user?.userName;
